(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.querySelector('.header__hamburger');
    const mobileMenu = document.getElementById('MobileMenu');

    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function () {
        toggleMobileMenu(this);
      });

      mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          toggleMobileMenu(hamburger);
        });
      });
    }

    function toggleMobileMenu(button) {
      const spans = button.querySelectorAll('span');
      const isActive = mobileMenu.classList.contains('active');

      mobileMenu.classList.toggle('active');
      button.classList.toggle('active');
      button.setAttribute('aria-expanded', !isActive);

      if (!isActive) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(7px, -6px)';
        spans.forEach((span) => (span.style.backgroundColor = '#000'));
      } else {
        spans[0].style.transform = 'none';
        spans[1].style.opacity = '1';
        spans[2].style.transform = 'none';
        spans.forEach((span) => (span.style.backgroundColor = '#fff'));
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
